import React from 'react';
import PropTypes from 'prop-types';

const NavigationRow = ({ handleClick, text, red, href, children }) => (
  <div className="navigation-row" data-cy={`nav-link-${text.toLowerCase()}`} onClick={handleClick}>
    <a className="navigation-anchor" href={href}>
      <span className="navigation-row-text">{text}</span>
    </a>
    {children}
    <style jsx>
      {`
        .navigation-row-text {
          color: ${text.toLowerCase() === 'sale' ? '#F25C5E' : 'black'};
          font-family: 'Avenir', 'Arial', sans-serif;
          font-size: 15px;
        }

        .navigation-row {
          border-bottom: 1px solid #eceeef;
          height: 50px;
          position: relative;
          font-weight: 300;
          text-transform: capitalize;
          color: ${red ? '#F25C5E' : '#222222'};
        }

        .navigation-anchor {
          text-decoration: none;
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: transparent;
          user-select: none;
          padding-left: 12px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          position: absolute;
        }
      `}
    </style>
  </div>
);

NavigationRow.propTypes = {
  children: PropTypes.element,
  handleClick: PropTypes.func,
  href: PropTypes.string,
  text: PropTypes.string,
  red: PropTypes.bool,
};

export default NavigationRow;
